import { StandardEvents } from '@shopify/events';

/**
 * Keeps the fixed cart action in sync with Shopify's cart events.
 * The theme's product forms and quick-add components dispatch the standard
 * cart lines update event after every successful cart change.
 */
class NoorStickyCart extends HTMLElement {
  connectedCallback() {
    this.countElement = this.querySelector('[data-noor-sticky-cart-count]');
    this.onCartUpdate = this.onCartUpdate.bind(this);
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
  }

  onCartUpdate(event) {
    event.promise
      ?.then(({ cart, detail }) => {
        this.renderCount(cart?.totalQuantity ?? detail?.itemCount ?? 0);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[noor-sticky-cart] Event promise rejected:', error);
      });
  }

  renderCount(count) {
    if (!this.countElement) return;

    this.countElement.textContent = String(count);
    this.dataset.empty = count === 0 ? 'true' : 'false';
  }
}

if (!customElements.get('noor-sticky-cart')) {
  customElements.define('noor-sticky-cart', NoorStickyCart);
}
